import React from "react";
import { Redirect } from "react-router-dom";
import useModules from "../../hooks/useModules";
import { CircularProgress, Box } from "@material-ui/core";

const ModuleGuard = ({ module, children }) => {
  const { isModuleEnabled, loading } = useModules();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (!isModuleEnabled(module)) {
    return <Redirect to="/" />;
  }

  return children;
};

export default ModuleGuard;
